import * as React from 'react';

export class CleverString extends String {
    constructor(value = '') {
        super(value);
    }

    isUpperCase = (char: any) => {
        return /[A-Z]/.test(char);
    };

    toKebabCase = () => {
        return this.split('')
            .map((currentCharacter, idx) => {
                const nextCharactor = this[idx + 1];
                if (this.isUpperCase(currentCharacter) &&
                    !(this.isUpperCase(nextCharactor) ||
                        !(this.isUpperCase(nextCharactor) && nextCharactor === " "))) {
                    return ((idx > 0) ? " " : "") + currentCharacter.toLowerCase();
                }
                return currentCharacter;
            })
            .join('')
            .replace(/_/g, '-')
            .replace(/\s+/g, '-');
    };

    toTitleCase = () => {
        return this.toKebabCase()
            .split('-')
            .map(currentWord => {
                return currentWord.slice(0, 1).toUpperCase() + currentWord.slice(1);
            })
            .join(' ');
    }

    toSentenceCase = () => {
        if (this.length == 0) {
            return this;
        }

        if (this.length > 1) {
            return this.slice(0, 1).toUpperCase() + this.toKebabCase().replace(/-/g, ' ').slice(1);
        }

        return this.substring(0, 1).toUpperCase;
    }

    toCamelCase() {
        return this.toKebabCase()
            .split('-')
            .map((currentWord, idx) => {
                if (idx === 0) return currentWord;
                return currentWord.slice(0, 1).toUpperCase() + currentWord.slice(1).toLowerCase()
            })
            .join('');
    }
};